window.captureException = require('@/utils/capture-exception').captureException;

// Decode global/env provided by the backend
import globals from "./configs/globals";
window.globals = globals;

import { importAppStorage } from "./utils/flutter/app-storage";
if (typeof window['FlutterInitService'] !== 'undefined') {
    window.importAppStorage = importAppStorage;
    window['FlutterInitService'].postMessage('init');
} else {
    if (typeof window.appStorage !== 'undefined') importAppStorage();
}

try {
    if (!("Tracker" in window)) {
        const { default: Tracker } = require("@/configs/tracker");

        window.Tracker = Tracker;
    }
} catch (error) {
    captureException(error);
}

import { getPackageName } from "./utils/flutter/package-name";
window.packageName = getPackageName();
Sentry.setTag("package_name", window.packageName);

const _props = ["calcs_created", "videos_watched", "animations_played", "emails_sent", "plans_saved"];
const _default = JSON.stringify({ dirty: false, value: 0, timestamp: Date.now() });
const TEN_MINUTES = 1000 * 60 * 10;

/**
 * @return {void}
 */
function initLocalStorageForAnalytics() {
    _props.forEach((prop) => {
        if (localStorage.getItem(prop)) return;

        localStorage.setItem(prop, _default);
    });
}

/**
 * @return {void}
 */
function flushLocalStorageForAnalytics() {
    _props.forEach((prop) => {
        const _object = JSON.parse(localStorage.getItem(prop) || '{}');

        // Check item is modified and check sending status.
        if (!_object.dirty) return;
        if ((Date.now() - _object.timestamp) < TEN_MINUTES) return;

        window.Tracker.logEvent({
            event_name: prop,
            event_label: "user_action",
            event_value: _object.value,
        });

        _object.dirty = false;
        _object.timestamp = Date.now();

        localStorage.setItem(prop, JSON.stringify(_object));
    });
}

/**
 *
 * @param {"calcs_created"|"videos_watched"|"animations_played"|"emails_sent"|"plans_saved"} prop
 * @return {void}
 */
function incrementLocalStorageForAnalyticsProp(prop) {
    const _object = JSON.parse(localStorage.getItem(prop));

    _object.value += 1;
    _object.dirty = true;

    localStorage.setItem(prop, JSON.stringify(_object));
}

window.incrementLocalStorageForAnalyticsProp = incrementLocalStorageForAnalyticsProp;

initLocalStorageForAnalytics();

let t;

if (!t) t = setInterval(flushLocalStorageForAnalytics, 1000 * 60 * 5);

// Import Vue core library
import Vue from "vue";
window.Vue = Vue;
Vue.config.productionTip = false;
Vue.config.silent = true;
Vue.config.devtools = false;

// Import Vuetify UI kit
// import Vuetify from "vuetify";
// Vue.use(Vuetify, {theme: { }});

import { setupVuetify } from "./configs/vuetify";
setupVuetify();

// Helpers
import "./extensions/modules/prototype-extends";
import "./extensions/helpers/helpers";
// import './modules/debug';

// Superagent
import "./configs/request";


// Import additional styles
import "./common/fonts/style.css"; // Ensure you are using css-loader
import "./common/main.css"; // Ensure you are using css-loader

// Import common PlanMaster Vue plugins
import PmAccessControl from "./extensions/modules/access-control";
Vue.use(PmAccessControl);
import PmEventBusPlugin from "./extensions/plugins/event-bus";
Vue.use(PmEventBusPlugin);
import pmGlobalsPlugin from "./extensions/plugins/globals";
Vue.use(pmGlobalsPlugin);
import PmInputRules from "./extensions/modules/input-rules";
Vue.use(PmInputRules);

import { autoLoadComponents } from "./components/common/index";
autoLoadComponents();

// Vue i18n - translations
import VueI18n from "vue-i18n";
import i18nOptions from "./configs/i18n"; // vue-18n with config
Vue.use(VueI18n);
const i18n = new VueI18n(i18nOptions);

// Vuex store
import store from "./extensions/vuex/store";
window.store = store;

// Vue router
import VueRouter from "vue-router";

// #region GLOBAL ROUTE ERROR HANDLER
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = async function push(location) {
    return await originalPush.call(this, location).catch(err => err);
}
// #endregion

Vue.use(VueRouter);
const router = new VueRouter({
    mode: "hash",
});
window.router = router;

window.i18n = i18n;

import App from "./components/App.vue";
import routes from "./configs/router";

// router.addRoutes(routes);
routes.forEach(route => router.addRoute(route));

router.beforeEach((to, from, next) => {
    window.Tracker.screenView(to.name);
    next();
});

import animationStore from "./extensions/vuex/store-animations";
window.store.registerModule("animation", animationStore);

// New language: only need add new item to `languageList` array.
import { importLanguage, languageList } from "./langs";
languageList.forEach((language) => importLanguage(language, i18n));

import StoreSmart from "./extensions/vuex/store-smart";
window.store.registerModule("smart", StoreSmart);

import { version } from "../package.json";

window.appVersion = version || "";

import { isIOS } from "./utils/device/is-ios";
Vue.prototype.$isIOS = isIOS;

window.WS = {
    channel: {
        bind() { },
    },
    send(evt) {
        Debug.log(`WEBSOCKET SEND: ${evt}`);
    },
};

window.logEvent = function (event, category, label, value) {
    window.Tracker.logEvent({
        event_name: event,
        event_category: category,
        event_label: label,
    });
};

import CloudSaveManager from "./extensions/managers/cloud-save-manager";
window.CloudSaveManager = CloudSaveManager;

import theme from "./configs/themes";
import { commands, semaphore } from './utils/flutter/flutter2-semaphore';
window.theme = theme.light;
Vue.prototype.$theme = window.theme;
Vue.prototype.$packageName = window.packageName;

try {
    require('./utils/firebase');
} catch (e) {
    captureException(e);
}

import mitt from 'mitt';
import { IAPupdateOfferings } from './utils/iap';
import { IAP } from './utils/iap';
if (!window.hasOwnProperty('IAP')) window.IAP = IAP;
Vue.prototype.$IAP = IAP;

import { flutterEventHandler } from './utils/flutter/event-handler';

try {
    const events = mitt();

    events.on('*', flutterEventHandler);

    // @ts-ignore
    window.events = events;
}
catch (error) {
    captureException(error);
}

try {
    const flutterVersion = localStorage.getItem('flutterVersion') || 'not set';
    Sentry.setTag("flutter_version", flutterVersion);
} catch (error) {

}

import { invokeFlutterService } from '@/utils/flutter/flutter-service';

window.app = new Vue({
    i18n,
    store,
    router,
    render: (h) => h(App),
    created() {
        if (typeof window.appStorage !== 'undefined') importAppStorage();
        window.addEventListener('offline', this.networkStatusManager);
        window.addEventListener('online', this.networkStatusManager);
    },
    async mounted() {
        await this.$nextTick();
        const task = setInterval(() => {
            if (typeof window.appStorage !== 'undefined') {
                clearInterval(task);
                this.notifyFlutterMounted();
                const initialPath = window.appStorage.get('initialPath');
                if (initialPath !== '') {
                    this.$router.push(initialPath);
                }
            }
        }, 50);
    },
    destroy() {
        window.removeEventListener('offline', this.networkStatusManager);
        window.removeEventListener('online', this.networkStatusManager);
    },
    methods: {

        /**
         *
         * @param {Event} event
         * @return {void}
         */
        networkStatusManager(event) {
            window.app.$bus.$emit('networkStatusChange', event.type);

            if (event.type === 'online') return;

            // - increase snackbar timeout, but disappear it after
            //   online status is available again
            // - progress bar is a good choice in snackbar?

            window.app.$bus.$emit('app.showSnackbar', {
                color: 'blue',
                text: window.app.$t('core.offline'),
            });
        },
        showProgress() { },
        hideProgress() { },
        showSnackbar() { },
        handleDeepLink(route = '/settings') {
            this.$router.push(route);
        },
        notifyFlutterMounted() {
            setTimeout(() => {
                if (typeof FlutterIsVueMountedService !== "undefined") invokeFlutterService('FlutterIsVueMountedService', 'mounted');
                if (('SemaphoreJavascriptChannel' in window)) semaphore({ name: commands.hook.command, data: { value: commands.hook.mounted } });
            }, 150);

            try {
                if ('SemaphoreChannel' in window) {
                    /** @type {import("@/types").Payload} */
                    const payload = {
                        command: 'hook',
                        data: {
                            name: 'mounted',
                        },
                    };
                    // invokeFlutterService('SemaphoreChannel', JSON.stringify(payload));
                    window['SemaphoreChannel'].postMessage(JSON.stringify(payload));
                }
            } catch (error) {
                captureException(error);
            }

            this.notifyFlutterMounted = () => { };
        },
        showError: alert,
    },
}).$mount("#app");
